import { render, staticRenderFns } from "./PopupsForm.vue?vue&type=template&id=898fc2cc&scoped=true"
import script from "./PopupsForm.vue?vue&type=script&lang=js"
export * from "./PopupsForm.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PopupsForm.vue?vue&type=style&index=1&id=898fc2cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898fc2cc",
  null
  
)

export default component.exports